import isObject from '../utility/isObject';

class ProductCategory {
  public static fragmentsFields(): string {
    return `
      id
      name
      display
    `;
  }

  public static fromJson(value: any): ProductCategory {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for ProductCategory.fromJson(value).');
    }

    const id = value['id'];
    const name = value['name'];
    const display = value['display'];

    if (typeof id !== 'string') {
      throw new TypeError('value.id must be a string for ProductCategory.fromJson(value).');
    }

    if (typeof name !== 'string') {
      throw new TypeError('value.name must be a string for ProductCategory.fromJson(value).');
    }

    return new ProductCategory({
      id,
      name,
      display,
    });
  }

  public id: string | null;
  public name: string;
  public display: boolean;

  constructor({
    id = null,
    name = '',
    display = true,
  }: {
    id?: string | null;
    name?: string;
    display?: boolean;
  }) {
    this.id = id;
    this.name = name;
    this.display = display;
  }

  public toJson(): object {
    return {
      name: this.name,
      display: this.display,
    };
  }
}

export default ProductCategory;
